
import Vue from 'vue'
import VueClipBoard from 'vue-clipboard2'
import { commonfunc } from '~/mixin/common'
import { getCdnUrl } from '~/scriptData/common/interM2'
import { wrapAlertMessage } from '~/utils/string'
import { getLambdaResizedImgUrl } from '~/scriptData/common/interLambda'

export default {
  components: {
  },
  mixins: [commonfunc],
  props: {
    shareData: {
      type: Object,
      default () { return {} }
    }
  },
  data () {
    return {
      snsVisible: false,
      snsList: [
        {
          id: 'kakao',
          icon: 'kakao',
          name: '카카오톡'
        },
        {
          id: 'line',
          icon: 'line',
          name: '라인'
        },
        {
          id: 'band',
          icon: 'band',
          name: '밴드'
        },
        {
          id: 'facebook',
          icon: 'facebook',
          name: '페이스북'
        }
      ],
      sendData: {
        title: '',
        description: '',
        url: '',
        imgUrl: ''
      }
    }
  },
  watch: {
    snsVisible (flag) {
      if (flag) {
        this.syncShareData()
      }
    },
    shareData: {
      deep: true,
      handler () {
        if (this.snsVisible) {
          this.syncShareData()
        }
      }
    }
  },
  mounted () {
    // // 카카오 SDK가 이미 초기화되었는지 확인
    // if (!window.Kakao.isInitialized()) {
    //   /* 카카오의 경우 javascript 키 발급하여 사용 */
    //   window.Kakao.init('5fbc60e7322b0c73f761f453f66b3702')
    // }
  },
  methods: {
    syncShareData () {
      this.sendData.url = this.shareData.url ?? window.location.href
      this.sendData.title = this.shareData.title
      this.sendData.description = this.shareData.description
      this.sendData.imgUrl = getCdnUrl(getLambdaResizedImgUrl(this.shareData.imgUrl, 'banner', '850'))
    },
    /* 카카오의 경우
      크게 기본 템플릿과 커스텀 템플릿, 스크랩이 존재하고,
      기본 템플릿에는 피드, 리스트, 위치, 커머스, 텍스트 등 5가지 종류가 있습니다.
      관련 링크 : https://developers.kakao.com/docs/latest/ko/message/js-link
      관련 문서 : https://developers.kakao.com/sdk/reference/js/release/Kakao.Share.html#.sendDefault
    */
    // 공통함수 toSNS : 카카오를 제외한 나머지 SNS 공유
    toSNS (sns) {
      const strTitle = this.sendData.title
      const description = this.sendData.description
      const strURL = this.sendData.url
      let chocSns = ''

      switch (sns) {
        case 'facebook':
          chocSns = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(strURL)
          window.open(chocSns, 'sns', 'resizable=no width=700 height=700')
          break
        case 'band':
          chocSns = 'http://band.us/plugin/share?body=' + encodeURIComponent(strTitle) + '  ' + encodeURIComponent(strURL) + '&route=' + encodeURIComponent(strURL)
          window.open(chocSns, 'sns', 'resizable=no width=700 height=700')
          break
        case 'line':
          chocSns = 'http://line.me/R/msg/text/?' + encodeURIComponent(strTitle) + ' ' + encodeURIComponent(strURL)
          window.open(chocSns, 'sns', 'resizable=no width=700 height=700')
          break
        case 'kakao' :
          if (window.Kakao) {
            // singleButton 플래그 확인
            const buttons = this.shareData.singleButton === true
              ? [
                  {
                    title: '지금 확인하러 가기',
                    link: {
                      mobileWebUrl: strURL,
                      webUrl: strURL
                    }
                  }
                ]
              : [
                  {
                    title: '웹으로 보기',
                    link: {
                      mobileWebUrl: strURL,
                      webUrl: strURL
                    }
                  }
                ]

            window.Kakao.Link.sendDefault({
              objectType: 'feed', // 사용할 종류
              content: {
                title: strTitle,
                description,
                imageUrl: this.sendData.imgUrl,
                // imageUrl 및 link의 url은 모두 도메인을 포함한 절대경로여야 한다.
                // 공유 링크
                link: {
                  mobileWebUrl: strURL,
                  webUrl: strURL
                }
              },
              buttons
            })
          }
          break
        case 'kakaoTemp' :
          window.Kakao.Link.sendCustom({
            // 카카오 developers에서 만든 메시지 템플릿 id
            templateId: 96916,
            // 카카오톡이 설치 되지 않았을때 마켓으로 이동
            installTalk: true
          })
          break
      }
    },

    // 현재 URL 복사
    copyClip () {
      // const url = window.location.protocol + '//' + window.location.host + window.location.pathname
      // this.$copyText(this.sendData.url)
      // alert('이 글의 단축url이 클립보드에 복사되었습니다.\n' + this.sendData.url)
      // nuxt 클립보드 이용해 복사
      VueClipBoard.config.autoSetContainer = true
      Vue.use(VueClipBoard)
      this.$copyText(this.sendData.url)
      this.$alert(wrapAlertMessage('URL이 복사되었습니다.'), '', { dangerouslyUseHTMLString: true })
    }
  }
}
